(function () {
  "use strict";

  var drawer = document.querySelector("[data-bb-drawer]");
  var overlay = document.querySelector("[data-bb-overlay]");
  if (!drawer || !overlay || drawer.dataset.bbBound === "1") return;
  drawer.dataset.bbBound = "1";

  var opener = null;
  var pending = false;
  var recsExpanded = null;

  function rootNode() {
    return drawer.querySelector("[data-bb-cart-root]");
  }

  function syncCount() {
    var node = rootNode();
    if (!node) return;
    var count = node.getAttribute("data-item-count") || "0";
    document.querySelectorAll(".header-cart__count").forEach(function (el) {
      el.textContent = count;
    });
  }

  function showError(message) {
    var error = drawer.querySelector("[data-bb-cart-error]");
    if (!error) return;
    error.hidden = !message;
    error.textContent = message || "";
  }

  function applyRecs() {
    var toggle = drawer.querySelector("[data-bb-recs-toggle]");
    var row = drawer.querySelector("[data-bb-recs]");
    if (!toggle || !row) return;
    if (recsExpanded === null) {
      recsExpanded = !(window.matchMedia && window.matchMedia("(max-width: 480px)").matches);
    }
    toggle.setAttribute("aria-expanded", String(recsExpanded));
    row.hidden = !recsExpanded;
  }

  function sectionUrl() {
    var current = new URL(window.location.href);
    var url = new URL("/cart", current.origin);
    url.searchParams.set("view", "bb-drawer");
    url.searchParams.set("sections", "cro-cart-drawer");
    var preview = current.searchParams.get("preview_theme_id");
    if (preview) url.searchParams.set("preview_theme_id", preview);
    return url.toString();
  }

  function refresh(addedTitle) {
    var previousWidth = barWidth();
    pending = true;
    drawer.classList.add("is-loading");
    drawer.setAttribute("aria-busy", "true");
    showError("");
    return fetch(sectionUrl(), { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("The cart could not be refreshed.");
        return response.json();
      })
      .then(function (data) {
        var html = data["cro-cart-drawer"];
        if (!html) throw new Error("The cart could not be refreshed.");
        var parsed = new DOMParser().parseFromString(html, "text/html");
        var next = parsed.querySelector("[data-bb-cart-root]");
        var current = rootNode();
        if (!next || !current) throw new Error("The cart could not be refreshed.");
        current.replaceWith(document.importNode(next, true));
        syncCount();
        applyRecs();
        if (addedTitle) {
          var added = drawer.querySelector("[data-bb-added]");
          if (added) {
            added.hidden = false;
            added.textContent = "Added: " + addedTitle;
          }
        }
        settleBars(previousWidth);
      })
      .catch(function (error) {
        showError(error.message || "Something went wrong. Please try again.");
      })
      .finally(function () {
        pending = false;
        drawer.classList.remove("is-loading");
        drawer.removeAttribute("aria-busy");
      });
  }

  function barWidth() {
    var bar = drawer.querySelector(".bb-cd-bar span");
    return bar ? bar.style.width : "";
  }

  function motionReduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function settleBars(previousWidth) {
    if (motionReduced()) return;
    drawer.querySelectorAll(".bb-cd-bar span").forEach(function (bar) {
      var target = bar.style.width;
      if (!target || !previousWidth || previousWidth === target) return;
      bar.style.width = previousWidth;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.style.width = target;
        });
      });
    });
  }

  function animateBars() {
    if (motionReduced()) return;
    drawer.querySelectorAll(".bb-cd-bar span").forEach(function (bar) {
      var target = bar.style.width;
      if (!target || target === "100%") return;
      bar.style.width = "0%";
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bar.style.width = target;
        });
      });
    });
  }

  function open(trigger) {
    opener = trigger || document.activeElement;
    document.documentElement.classList.add("bb-cd-lock");
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    animateBars();
    var closeButton = drawer.querySelector("[data-bb-close]");
    if (closeButton) window.setTimeout(function () { closeButton.focus(); }, 30);
  }

  function close() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.documentElement.classList.remove("bb-cd-lock");
    if (opener && typeof opener.focus === "function") opener.focus();
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var message = data && (data.description || data.message);
          if (data && typeof data.errors === "string") message = data.errors;
          throw new Error(message || "Could not update the cart.");
        }
        return data;
      });
    });
  }

  overlay.addEventListener("click", close);

  drawer.addEventListener("click", function (event) {
    if (event.target.closest("[data-bb-close]")) {
      close();
      return;
    }

    var toggle = event.target.closest("[data-bb-recs-toggle]");
    if (toggle) {
      recsExpanded = toggle.getAttribute("aria-expanded") !== "true";
      applyRecs();
      return;
    }

    var qtyButton = event.target.closest("[data-bb-qty]");
    if (qtyButton) {
      if (pending) return;
      post(drawer.dataset.cartChange + ".js", {
        id: qtyButton.getAttribute("data-bb-qty"),
        quantity: Number(qtyButton.getAttribute("data-bb-qty-value"))
      }).then(function () {
        return refresh();
      }).catch(function (error) {
        showError(error.message);
      });
      return;
    }

    var addButton = event.target.closest("[data-bb-add]");
    if (!addButton || pending) return;
    var variantId = addButton.getAttribute("data-bb-add");
    var selectId = addButton.getAttribute("data-bb-add-select");
    if (selectId) {
      var select = document.getElementById(selectId);
      if (!select || !select.value) {
        showError("Choose an option before adding this product.");
        if (select) select.focus();
        return;
      }
      variantId = select.value;
    }
    addButton.disabled = true;
    post(drawer.dataset.cartAdd + ".js", { id: Number(variantId), quantity: 1 })
      .then(function (item) {
        return refresh(item.product_title || item.title);
      })
      .catch(function (error) {
        showError(error.message);
      })
      .finally(function () {
        addButton.disabled = false;
      });
  });

  drawer.addEventListener("change", function (event) {
    var select = event.target.closest("[data-bb-variant-select]");
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var card = select.closest(".bb-cd-pair-row, .bb-cd-rec");
    var slot = card && card.querySelector("[data-bb-suggest-price]");
    if (!slot || !option) return;
    var price = option.getAttribute("data-price") || "";
    var compare = option.getAttribute("data-compare") || "";
    slot.textContent = "";
    var wrap = document.createElement("span");
    wrap.className = "bb-price" + (compare ? " bb-price--sale" : "");
    var current = document.createElement("span");
    current.className = "bb-price__current";
    current.textContent = price;
    wrap.appendChild(current);
    if (compare) {
      var struck = document.createElement("s");
      struck.className = "bb-price__compare";
      struck.textContent = compare;
      wrap.appendChild(struck);
    }
    slot.appendChild(wrap);
  });

  document.addEventListener("keydown", function (event) {
    if (!drawer.classList.contains("is-open")) return;
    if (event.key === "Escape") {
      close();
      return;
    }
    if (event.key !== "Tab") return;
    var focusable = Array.prototype.filter.call(
      drawer.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex="0"]'),
      function (el) { return !el.hidden && el.getClientRects().length > 0; }
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener("click", function (event) {
    var link = event.target.closest(".header-cart a, [data-bb-cart-open]");
    if (!link) return;
    if (!window.theme || !theme.settings || theme.settings.onAddToCart !== "drawer") return;
    event.preventDefault();
    open(link);
  });

  document.addEventListener("bb:cart:added", function (event) {
    var detail = event.detail || {};
    var title = detail.product_title || detail.title || "";
    refresh(title).then(function () { open(); });
  });

  syncCount();
  applyRecs();
})();
